<template>
  <SFItemsSlider
    class="w-full snap-x snap-mandatory scrollbar-hide"
    slider-class="py-1"
  >
    <SFCategoryNavigationSliderItem
      v-for="category in categories"
      :key="category.id"
      :is-brand-listing="isBrandListing"
      :category="category"
      :is-active="category.id === currentCategory?.id"
      class="mr-2"
    />
  </SFItemsSlider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Category } from '@scayle/storefront-nuxt'
import SFCategoryNavigationSliderItem from './SFCategoryNavigationSliderItem.vue'
import { SFItemsSlider } from '#storefront-ui/components'
import { useRoute } from '#app/composables/router'

const { allCategories, currentCategory } = defineProps<{
  allCategories: Category[]
  currentCategory: Category | null
}>()

const route = useRoute()

const isBrandListing = computed(() => {
  return (
    route.path.includes('/b/') ||
    currentCategory?.slug === 'brands' ||
    currentCategory?.parent?.slug === 'brands'
  )
})

const categories = computed(() => {
  // If the category is a leaf node, select all categories which have the same parent
  if (currentCategory?.childrenIds.length === 0) {
    return allCategories.filter((item) => {
      return currentCategory.parentId === item.parentId
    })
  }

  // If the category has children, we return all categories which have our current category as a parent
  return allCategories.filter((item) => {
    return currentCategory?.id === item.parentId
  })
})
</script>
